/**
 * Battery gauge: the pure parts of the bars display. The server works out the
 * bars from the charge the pack has used (Device.battery_bars: 4, 3, 2 or 1, and 0
 * for critical, the last 15% of the 18,000 mAh pack); this module only turns
 * them into what the bars show.
 */

export const BATTERY_BARS = 4;

/** True once the battery job has measured the device; until then the voltage-based percentage is shown. */
export function hasBatteryGauge(bars) {
  return bars !== null && bars !== undefined;
}

/** "ok" for 4, 3 or 2 bars, "low" for the last bar, "critical" for the last 15%. */
export function batteryGaugeLevel(bars) {
  if (bars <= 0) return "critical";
  if (bars === 1) return "low";
  return "ok";
}

/**
 * One number to sort devices by battery, whichever way each one is measured:
 * the share of the pack left when the gauge has it, else the voltage-based
 * percentage. Undefined for no device, as the old sort had.
 */
export function batterySortValue(device) {
  if (!device) return undefined;
  if (hasBatteryGauge(device.battery_bars) && device.battery_capacity_mah) {
    return (100 * device.battery_remaining_mah) / device.battery_capacity_mah;
  }
  return device.battery;
}

/** Tooltip and screen-reader text for the bars. */
export function batteryGaugeLabel(bars) {
  return batteryGaugeLevel(bars) === "critical"
    ? "Battery critical"
    : `Battery ${bars} of ${BATTERY_BARS} bars`;
}
